const benefits = [
  {
    icon: 'ri-award-line',
    title: 'Major Manufacturer Certified',
    description:
      'Certified by GAF, Tamko, Duralast, Mulehide, and Owens Corning. Manufacturer certifications mean you get enhanced warranties and proven installation standards on every project.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Engineer On Staff',
    description:
      'We have a licensed structural engineer on our team. Every project benefits from expert assessment, ensuring your roof meets all NJ building codes and structural requirements.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '24-Hour Emergency Service',
    description:
      'Roof emergencies don\'t follow business hours. Our rapid-response crew is available 24 hours a day, 7 days a week across all of New Jersey. Call (856) 677-6191 anytime.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'NJ & PA Statewide Coverage',
    description:
      'From Cape May to Bergen County in NJ, and throughout the entire state of Pennsylvania — one call gets you the same professional crew and quality materials, no matter where your building is.',
  },
  {
    icon: 'ri-group-line',
    title: 'Clean, Courteous Crews',
    description:
      'Our employees take pride in their work and your property. Job sites are kept clean and organized throughout, and our team is always respectful and professional.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Fully Licensed & Insured',
    description:
      'Every job is backed by full NJ contractor licensing and comprehensive liability insurance. You\'re completely protected from start to completion on every project we undertake.',
  },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-24 text-white bg-black relative overflow-hidden">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black z-0" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-xs tracking-widest text-orange-400 uppercase mb-3">Why choose us</p>
            <h2 className="text-4xl md:text-5xl font-display font-light tracking-tight">
              Serving NJ &amp; PA —<br />The Difference We Make
            </h2>
          </div>
          <a
            href="tel:8566776191"
            className="flex items-center gap-3 px-6 py-3 border border-orange-400/60 text-orange-300 hover:bg-orange-600 hover:text-white hover:border-orange-600 transition-colors cursor-pointer whitespace-nowrap w-fit"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            <span className="text-sm font-medium">(856) 677-6191</span>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {benefits.map((b) => (
            <div key={b.title} className="flex flex-col gap-4 p-6 border border-white/10 hover:border-orange-400/40 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${b.icon} text-2xl text-orange-400`} />
              </div>
              <h3 className="text-base font-medium">{b.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>

        {/* Manufacturer logos strip */}
        <div className="mt-16 border-t border-white/10 pt-12">
          <p className="text-xs tracking-widest text-gray-500 uppercase mb-7 text-center">Certified With Leading Manufacturers</p>
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
            {['GAF', 'Tamko', 'Duralast', 'Mulehide', 'Owens Corning'].map((brand) => (
              <div
                key={brand}
                className="px-6 py-3 border border-white/20 text-sm font-medium tracking-wider text-gray-300"
              >
                {brand}
              </div>
            ))}
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-12">
          {[
            { value: 'NJ & PA', label: 'Full State Coverage' },
            { value: '24/7', label: 'Emergency Response' },
            { value: '5', label: 'Major Certifications' },
            { value: '1', label: 'Engineer On Staff' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl font-display font-light mb-1">{stat.value}</p>
              <p className="text-xs text-gray-400 tracking-wide">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
